<!-- VideoComponent.vue -->
<template>
    <div>
      <video controls :src="url" class="video-player">
        Your browser does not support the video tag.
      </video>
    </div>
  </template>
  
  <script>
  export default {
    props: ['url']
  }
  </script>
  
  <style>
  .video-player {
    width: 100%;
    max-height: 500px;
  }
  </style>
  